import React, { Component } from 'react';
import { connect } from 'react-redux';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';
import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('TRANSACTION_REPORT_VATRETURN', LOG_LEVELS.DEBUG);

class ReportVATReturn extends Component {

  render() {
    log.debug('render(): ', this.props);

    if (!this.props.src) {
      return(
        <div><LanguageStringResolver string='transactionBlank_noData'/></div>
      )
    }

    return(
      <div>
        {this.props.src.map((item, index) => (
        <div key={index}>
          <h2 className="mt0 mb0"><LanguageStringResolver string='transactionInvoice_VATReturn'/> - <LanguageStringResolver string='transactionInvoice_countryCode'/> - <span className="mt0 semi-bold uppercase">{item.country}</span></h2>
          <table className="mb20">
            <thead>
              <tr>
                <th className="quarter-width"><span><LanguageStringResolver string='transactionInvoice_boxName'/></span></th>
                <th className="quarter-width"><span><LanguageStringResolver string='transactionInvoice_timeType'/></span></th>
                <th className="quarter-width"><span><LanguageStringResolver string='transactionInvoice_value'/></span></th>
                <th className="quarter-width"><span><LanguageStringResolver string='transactionInvoice_value'/></span></th>
              </tr>
            </thead>
            <tbody>
              {item.vatReturnDetails.map((box, subidx) => (
                <tr key={subidx}>
                  <td>{box.boxName}</td>
                  <td>{box.timeType_str}</td>
                  <td><FormattedCurrencyValue value={box.boxValue}/></td>
                  <td>{box.boxType_str}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        ))}
      </div>
   );
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {};
}


function mapDispatchersToProps(dispatch) {
  return {}
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(ReportVATReturn);
